module.exports = __webpack_public_path__ + "862a2abd4b554e356874e0f951b4d12c.svg";